import { bookingHomeMenuItems } from '@/assets/data';
import { findAllParent, findMenuItem, getAppMenuItems, getMenuItemFromURL } from '@/helpers/menu';
import clsx from 'clsx';
import { Fragment, useCallback, useEffect, useState } from 'react';
import { Collapse, Dropdown, DropdownItem, DropdownMenu, DropdownToggle, Nav } from 'react-bootstrap';
import { FaAngleDown, FaBed, FaChevronDown, FaEllipsis, FaSuitcaseRolling } from 'react-icons/fa6';
import Link from 'next/link';
import { usePathname } from 'next/navigation';
const MenuItemWithChildren = ({
  item,
  activeMenuItems,
  itemClassName,
  linkClassName,
  level
}) => {
  const level1 = level === 1;
  return <Dropdown className={itemClassName} drop={level >= 2 ? 'end' : undefined}>
      <DropdownToggle as={Link} className={clsx(linkClassName, 'badge-hit')} href="#" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
        {item.label}
        {level1 ? <FaChevronDown size={12} /> : <FaEllipsis size={14} />}
      </DropdownToggle>
      <DropdownMenu aria-labelledby="listingMenu" data-bs-popper="none" renderOnMount>
        {(item.children ?? []).map((child, idx) => <Fragment key={idx + child.key + idx}>
            {child.children ? <MenuItemWithChildren item={child} level={level + 1} activeMenuItems={activeMenuItems} itemClassName="dropdown-submenu" linkClassName={clsx('dropdown-item dropdown-toggle arrow-none d-flex align-items-center justify-content-between', {
          active: activeMenuItems?.includes(child.key)
        })} /> : <MenuItem item={child} level={level + 1} linkClassName={clsx(activeMenuItems?.includes(child.key) && 'active')} />}
          </Fragment>)}
      </DropdownMenu>
    </Dropdown>;
};
const MenuItem = ({
  item,
  linkClassName,
  level
}) => {
  return <MenuItemLink item={item} linkClassName={linkClassName} level={level} />;
};
const MenuItemLink = ({
  item,
  linkClassName,
  level
}) => {
  if (level === 1) {
    // Top-level items should be Nav.Link for proper alignment
    return (
      <li className="nav-item">
        <Link 
          href={item.url ?? ''} 
          target={item.target} 
          className={clsx('nav-link', linkClassName, 'badge-hit')}
        >
          {item.label}
        </Link>
      </li>
    );
  }
  // Nested items use DropdownItem
  return <DropdownItem as={Link} href={item.url ?? ''} target={item.target} className={clsx(linkClassName, 'badge-hit')}>
      {item.label}
    </DropdownItem>;
};
const AppMenu = ({
  startBookingMenu,
  mobileMenuOpen,
  menuClassName,
  embedded = false,
}) => {
  const [activeMenuItems, setActiveMenuItems] = useState([]);
  const menuItems = getAppMenuItems();
  const pathname = usePathname();

  /**
   * activate the menuitems
   */
  const activeMenu = useCallback(() => {
    const matchingMenuItem = getMenuItemFromURL(menuItems, pathname);
    if (matchingMenuItem) {
      const activeMt = findMenuItem(menuItems, matchingMenuItem.key);
      if (activeMt) {
        setActiveMenuItems([activeMt.key, ...findAllParent(menuItems, activeMt)]);
      }
    }
  }, [pathname, menuItems]);
  useEffect(() => {
    activeMenu();
  }, [activeMenu, menuItems]);

  const inner = (
      <div>
        {startBookingMenu && <ul className="navbar-nav navbar-nav-scroll me-auto">
            <Dropdown className="nav-item">
              <DropdownToggle as={Link} className="nav-link rounded px-3 py-3 py-xl-0 arrow-none flex-centered gap-1 badge-hit" href="#" id="categoryMenu" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                <span className="me-auto items-center gap-1">
                  <FaSuitcaseRolling /> Travelers
                </span>
                <FaAngleDown size={12} />
              </DropdownToggle>
              <DropdownMenu aria-labelledby="categoryMenu" renderOnMount>
                {(bookingHomeMenuItems ?? []).map((item, idx) => {
              const Icon = item.icon ?? FaBed;
              const activeItem = item.url == pathname;
              return <li className="mb-1" key={item.key + idx}>
                      <Link href={item.url ?? ''} className={clsx('dropdown-item bg-light-hover d-flex align-items-center rounded p-2', {
                  active: activeItem
                }, 'badge-hit')}>
                        <div className="icon-md bg-primary bg-opacity-10 rounded text-primary flex-shrink-0">
                          <Icon />
                        </div>
                        <div className="ms-2">
                          <h6 className="mb-0">{item.label}</h6>
                          <p className="small mb-0 text-body">Small description here</p>
                        </div>
                      </Link>
                    </li>;
            })}
              </DropdownMenu>
            </Dropdown>
          </ul>}

        <Nav className={clsx('navbar-nav navbar-nav-scroll me-auto', menuClassName)}>
          {(menuItems ?? []).map((item, idx) => {
          return <Fragment key={item.key + idx}>
                {item.children ? <MenuItemWithChildren item={item} activeMenuItems={activeMenuItems} level={1} itemClassName="nav-item" linkClassName={clsx('nav-link arrow-none d-flex align-items-center gap-1 justify-content-between', {
              active: activeMenuItems.includes(item.key)
            })} /> : <MenuItem item={item} level={1} linkClassName={clsx(activeMenuItems.includes(item.key) && 'active')} />}
              </Fragment>;
        })}

        </Nav>
      </div>
  );

  if (embedded) {
    return <div className="app-menu-embedded">{inner}</div>;
  }

  return (
    <Collapse in={Boolean(mobileMenuOpen)} className="navbar-collapse">
      {inner}
    </Collapse>
  );
};
export default AppMenu;